module.exports = __webpack_public_path__ + "static/img/mac_icon.aed5b78c.png";